import React from 'react';
import { formatDate } from '../utils';

const CategorySpecificSection = ({ ticket, loading, handleDownload }) => {
  return (
    <div className="mb-6 p-6 rounded-xl border border-amber-500/20 shadow-lg relative bg-gradient-to-br from-amber-50 to-amber-100 before:content-[''] before:absolute before:top-0 before:left-0 before:w-1 before:h-full before:bg-gradient-to-b before:from-amber-500 before:to-amber-400 before:rounded-l-sm">
      <h3 className="text-slate-900 font-bold mb-4 font-poppins flex items-center gap-3 text-xl">
        ⚙️ {ticket.categorySpecificDetails.type} Details
      </h3>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        {Object.entries(ticket.categorySpecificDetails.details).map(([key, value]) => {
          // Skip basic fields already shown and file-related fields
          if (!value || 
              key === 'fileName' || 
              key === 'filePath' || 
              key === 'originalFileName' || 
              key === 'fileType' || 
              key === 'fileSize' ||
              key === 'name' ||
              key === 'email' ||
              key === 'location' ||
              key === 'department' ||
              key === 'documentType' ||
              key === 'accountType' ||
              key === 'taType') return null;
          
          // Skip fields that are shown in the Basic Information section
          if ((key === 'documentType' && ticket.documentType) ||
              (key === 'accountType' && ticket.accountType) || 
              (key === 'taType' && ticket.taType)) return null;
          
          // Handle object values
          let displayValue = value;
          if (typeof value === 'object' && value !== null) {
            displayValue = value.name || value.type || JSON.stringify(value);
          }
          
          return (
            <div key={key} className="col-span-1">
              <div className="p-4 bg-white rounded-lg border border-amber-500/15 shadow-sm hover:shadow-md hover:-translate-y-0.5 transition-all duration-200">
                <p className="font-poppins font-semibold text-xs uppercase tracking-wider mb-2 text-amber-700">
                  {key.charAt(0).toUpperCase() + key.slice(1).replace(/([A-Z])/g, ' $1')}
                </p>
                <p className="font-semibold font-poppins text-slate-900 text-base">
                  {key === 'dateOfRequest' ? formatDate(displayValue) : (Array.isArray(displayValue) ? displayValue.join(', ') : displayValue)}
                </p>
              </div>
            </div>
          );
        })}
      </div>
      
      {/* Document Download Button */}
      {ticket.category === 'DOCUMENT_UPLOAD' && ticket.categorySpecificDetails?.details?.fileName && (
        <div className="mt-6 text-center">
          <button
            onClick={handleDownload}
            disabled={loading}
            className="py-4 px-6 rounded-xl font-semibold font-poppins text-base bg-amber-500 text-white shadow-lg hover:bg-amber-600 hover:shadow-xl hover:-translate-y-0.5 disabled:bg-gray-400 disabled:text-gray-600 disabled:cursor-not-allowed disabled:hover:transform-none disabled:hover:shadow-lg transition-all duration-300"
          >
            {loading ? '⏳ Downloading...' : `📥 Download ${ticket.categorySpecificDetails.details.originalFileName || 'Attached Document'}`}
          </button>
        </div>
      )}
    </div>
  );
};

export default CategorySpecificSection;